import React, { Component } from 'react';
import { Field, reduxForm } from 'redux-form';
import PropTypes from 'prop-types';
import {renderCheckbox, renderTextField} from "../../utils/form";
import {loadStatesForSelect} from "../../actions/State/forSelect";
import {connect} from 'react-redux';
import RichTextEditor from "../../views/Components/RichTextEditor";
import InlineFileUpload from "../../views/Components/InlineFileUpload";
import SearchableSelect from "../../views/Components/SearchableSelect";
import {loadCountriesForSelect} from "../../actions/Country/forSelect";

class CompanyForm extends Component {
  static propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    error: PropTypes.string,
    isNew: PropTypes.bool,
  };

  constructor(props) {
    super(props);
    this.state = {
      showWhiteLabelOptions: (props.initialValues) ? props.initialValues.whiteLabelEnabled : false,
      country: props && props.initialValues && ('country' in props.initialValues) ? props.initialValues['country'] : null,
    };
  }

  componentDidMount() {
    this.props.loadCountriesForSelect(this.props.site.country && this.props.site.country.code);
    this.props.loadStatesForSelect();
  }

  handleCountrySelect = (e, value, oldValue) => {
    if (value !== oldValue) {
      this.props.change('state', null);

      this.setState({country: value});
    }
  };

  render() {
    let stateOptions = [];
    if (this.state.country !== null) {
      if (this.props.states) {
        this.props.states.map(state => {
          if (state.country === this.state.country) {
            stateOptions.push(state);
          }
        });
      }
    }

    return (
      <form onSubmit={this.props.handleSubmit}>
        <Field
          component={renderTextField}
          name="name"
          type="text"
          placeholder="Name"
          required={true}
        />
        <Field
          component={SearchableSelect}
          name="status"
          label="Status"
          placeholder="Select Status"
          required={true}
          options={[
            {text: "Active", value: "active"},
            {text: "Inactive", value: "inactive"},
          ]}
        />
        <Field
          component={renderTextField}
          name="address"
          type="text"
          placeholder="Address"
          required={true}
        />
        <Field
          component={renderTextField}
          name="address2"
          type="text"
          placeholder="Address 2"
        />
        <Field
          component={renderTextField}
          name="city"
          type="text"
          placeholder="City"
          required={true}
        />
        <Field
          component={SearchableSelect}
          name="country"
          label="Country"
          placeholder={this.props.countries ? 'Select Country' : 'Loading...'}
          options={this.props.countries ? this.props.countries : []}
          required={true}
          onChange={this.handleCountrySelect}
        />
        {stateOptions.length > 0 && (
          <Field
            component={SearchableSelect}
            name="state"
            label="State"
            placeholder="Select State"
            options={stateOptions}
            required={true}
            isDisabled={!this.state.country}
          />
        )}
        <Field
          component={renderTextField}
          name="zipCode"
          type="text"
          placeholder="Zip Code"
          required={true}
        />
        <Field
          component={RichTextEditor}
          name="description"
          placeholder="Description"
          required={true}
        />
        <Field
          component={renderTextField}
          name="phoneNumber"
          type="text"
          placeholder="Phone Number"
          required={true}
        />
        <Field
          component={renderTextField}
          name="emailAddress"
          type="text"
          placeholder="Email Address"
          required={true}
        />
        <Field
          component={renderTextField}
          name="webSite"
          type="text"
          placeholder="Web Site"
          required={true}
        />
        <Field
          component={InlineFileUpload}
          type="image"
          accept=".jpg, .png, .jpeg"
          name="logo"
        />
        <Field
          component={renderCheckbox}
          name="allowCandidateToViewOneWayInterviews"
          label="Allow Candidates to View On Demand Interviews"
        />
        <Field
          component={renderCheckbox}
          name="allowCandidateToViewLiveInterviews"
          label="Allow Candidates to View Live Interviews"
        />
        <Field
          component={renderCheckbox}
          name="whiteLabelEnabled"
          label="Allow Company Customize Site"
          onChange={(event) => this.setState({showWhiteLabelOptions: event.currentTarget.checked})}
        />
        {this.state.showWhiteLabelOptions && (
        <>
          <Field
            component={renderTextField}
            name="whiteLabelDomain"
            type="text"
            placeholder="Site Domain"
            label="Site Domain"
            required={true}
          />
          <Field
            component={renderTextField}
            name="whiteLabelFromEmail"
            type="text"
            placeholder="Site From Email"
            label="Site From Email"
            required={true}
          />
          <Field
            component={renderTextField}
            name="whiteLabelEmailAddress"
            type="text"
            placeholder="Site Email"
            label="Site Email"
            required={true}
          />
          <Field
            component={renderTextField}
            name="whiteLabelPrivacyEmail"
            type="email"
            placeholder="Site Privacy Email Address"
            label="Privacy Email"
            required={true}
          />
          <Field
            component={renderTextField}
            name="whiteLabelHomePageSlogan"
            placeholder="Home Page Slogan"
            label="Home Page Slogan"
          />
          <Field
            component={InlineFileUpload}
            type="image"
            accept=".ico, .png, .gif, .jpg, .jpeg, .svg"
            name="whiteLabelFavicon"
            label="Favicon"
          />
        </>
        )}
        {this.props.isNew && (
          <>
          <hr/>
          <h2>Company Admin</h2>

          <Field
            component={renderTextField}
            type="text"
            name="[users][0][firstName]"
            placeholder="First Name"
            label="First Name"
            required={true}
          />
          <Field
            component={renderTextField}
            type="text"
            name="[users][0][lastName]"
            placeholder="Last Name"
            label="Last Name"
            required={true}
          />
          <Field
            component={renderTextField}
            type="text"
            name="[users][0][email]"
            placeholder="Email Address"
            label="Email Address"
            required={true}
          />
          <Field
            component={renderTextField}
            type="text"
            name="[users][0][phoneNumber]"
            placeholder="Phone Number"
            label="Phone Number"
            required={true}
          />
          <Field
            component={renderTextField}
            type="password"
            name="[users][0][plainPassword]"
            placeholder="Password"
            label="Password"
            required={true}
          />
          <Field
            component={renderTextField}
            type="password"
            name="[users][0][confirmPassword]"
            placeholder="Confirm Password"
            label="Confirm Password"
            required={true}
          />
          <Field
            component={renderCheckbox}
            name="[users][0][receiveNotifications]"
            label="Receive Email Notifications"
          />
          </>
        )}

        <button type="submit" className="btn btn-success float-left mr-3">
          Submit
        </button>
      </form>
    );
  }
}

const requiredState = value => value ? undefined : 'Please select State';

const mapStateToProps = state => {
  let countries = state.country.forSelect.retrieved;
  let states = state.state.forSelect.retrieved;
  let site =  state.siteDetails.siteDetails.retrieved;

  return { countries, states, site};
};

const mapDispatchToProps = dispatch => ({
  loadCountriesForSelect: (countryCode) => dispatch(loadCountriesForSelect('@id', countryCode)),
  loadStatesForSelect: () => dispatch(loadStatesForSelect('@id')),
});

const validate = (values) => {
  const errors = {};
  if (!values.country) {
    errors['country'] = 'This field should not be blank.';
  }

  if (!values.description) {
    errors['description'] = 'This field should not be blank.'
  }

  if (!values.webSite) {
    errors['webSite'] = 'This field should not be blank.'
  }

  return errors;
}

CompanyForm = reduxForm({
  form: 'company',
  enableReinitialize: true,
  keepDirtyOnReinitialize: true,
  validate: validate
})(CompanyForm);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CompanyForm);
